import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤 — 레거시 머리 칸은 td.title */
export const InfluencerPplRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& .form-group + .form-group': { marginTop: 16 },
  '& table': {
    ...approvalFormTableStyles(theme),
    minWidth: 560,
  },
  '& th, & td': { wordBreak: 'keep-all', overflowWrap: 'anywhere' },
  '& td.title': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
    fontWeight: 500,
  },
  '& .text-center, & .center': { textAlign: 'center' },
  '& .text-left': { textAlign: 'left' },
  '& .text-right': { textAlign: 'right' },
  '& td.ppl-purpose, & .ppl-purpose-text': { whiteSpace: 'pre-wrap' },
  '& .ppl-images, & .d-flex.align-items-start': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 8,
  },
  '& .ppl-images img, & img.img-responsive': {
    width: '20%',
    maxWidth: '20%',
    height: 'auto',
  },
  '& .ppl-graph': { width: '100%', overflowX: 'auto', padding: '16px 0 8px' },
}));

export const InfluencerPplPurposeCell = styled('td')({
  '&&': { padding: 6 },
});

export const InfluencerPplGraphBox = styled(Box)({
  flex: 1,
  width: '100%',
  minWidth: 600,
});

/** 레거시 펼침 칸 45px = 좌우 여백 + 버튼 28px */
export const InfluencerPplRowToggleButton = styled(IconButton)({
  width: 28,
  height: 28,
  '& svg': { width: 12, height: 12 },
});

export const InfluencerPplDetailRoot = styled(InfluencerPplRoot)({
  '& table': { minWidth: 720 },
  '& table + table': { marginTop: 8 },
  '& th, & td': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& tr.ppl-detail-subtotal td, & tr.ppl-detail-total td': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
    fontWeight: 600,
  },
});

export const InfluencerPplSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
